<template>
	<div class="m-auto" style="max-width:1100px">

		<!-- GH: Reubicar -->
		<b-toast id="toast-check-internet" variant="none" no-close-button toaster="b-toaster-top-right">
			<img src="@/assets/img/ico-check.png" style="margin-right: 10px; margin-top: -2px"/>
			Se restauro la Conexión
		</b-toast>
		<b-toast id="toast-equis-internet" variant="none" no-close-button toaster="b-toaster-top-right">
			<img src="@/assets/img/ico-equis.png" style="margin-right: 10px; margin-top: -2px" />
			Sin Conexión
		</b-toast>

		<b-modal id="modal-nose-1" size="md" :hide-footer="true" :hide-header="true" :centered="true">
			<h4> ¿Deseas abandonar la página?</h4>	
			<div class="buttons" style="display: flex;justify-content: flex-end;">
				<b-button class="ml-3" @click="console.log(321)" variant="link">Aceptar</b-button>
				<b-button class="ml-3" @click="$bvModal.hide('modal-nose-1')" variant="link">Cancelar</b-button>
			</div>
		</b-modal>
		<!------------------------------------------------------------------------------------------>

		<div class="back-step" @click="backStep" v-if="(step == 0 || step == 2) && !flagEvalGroup" >
			<icon name="arrow-left" />{{$t('planesYPrecios.paso-3.evaluacion.buttons.regresar')}}
		</div>
    	<h6 class="sub-title">{{$t('planesYPrecios.paso-3.titulo')}}<span>{{$t('planesYPrecios.paso-3.subTitulo')}}</span></h6>
		<div v-if="step == 0" class="card card_evaluation" >
			
			<div class="card-body" v-show="duration != 0">
				<b-row>
					<b-col cols="7" >
						<p>{{$t('planesYPrecios.paso-3.preselección.texto-recomendacion')}}</p>
						<h4 class="red mb-4">{{$t('planesYPrecios.paso-3.preselección.indicacion')}}</h4>
						<div class="indications">
							<h6>{{$t('planesYPrecios.paso-3.preselección.titulo-indicacion')}}:</h6>
							<ul>
								<li>{{$t('planesYPrecios.paso-3.preselección.texto-indicación.1')}} {{duration}} {{$t('planesYPrecios.paso-3.preselección.texto-indicación.1-1')}}</li>
								<li>{{$t('planesYPrecios.paso-3.preselección.texto-indicación.2')}}</li>
							</ul>
						</div>
						<b-button :disabled="!carga_evaluacion_flag"  variant="primary" @click="step = 1;">{{carga_evaluacion_mje}}</b-button>
					</b-col>
					<b-col cols="5">
						<img class="img-first" src="@/assets/img/evaluation-1.png" />
					</b-col>
				</b-row>
			</div>
		</div>
		
		<template v-else-if="step == 1"  >
			<EvaluacionPreguntas :evaluation="evaluation"  
									:questions="questions"  
									@listenChild="evaluationValueChild" 
									>

			</EvaluacionPreguntas>
		</template>
		<template v-else-if="step == 2 & flag_resultados" >
			<div class="quiz-status">
				<p v-if="evaluationData.duration"><icon name="time" />{{$t('planesYPrecios.paso-3.resultado.tiempo')}}: <b>{{evaluationData.duration}} {{$t('planesYPrecios.paso-3.resultado.minutos')}}</b></p>
				<p v-if="evaluationData.answersCorrect"><icon name="help" />{{$t('planesYPrecios.paso-3.resultado.respuestas')}}: <b>{{evaluationData.answersCorrect}}</b></p>
			</div>
			<div class="card card_evaluation_result mb-5">
				<div class="card-body">
					<b-row>
						<b-col class="text-center d-flex flex-column">
							<h4>
								<icon name="star" />{{$t('planesYPrecios.paso-3.resultado.info.nivel')}}<icon name="star" />
								<span>{{$t('planesYPrecios.paso-3.resultado.info.nivel-2')}}</span>
							</h4>
							<div class="level-box" :id="'level_'+ evaluationData.level.id" :class="'gd-'+evaluationData.level.id"> 
								<h1>{{evaluationData.level.abbreviation}}</h1>
								<span>{{evaluationData.level.name}}</span>
							</div>
							<b-link v-show="false" v-b-modal.modal-niveles>{{$t('planesYPrecios.paso-3.resultado.info.ver-nivel')}}</b-link>
						</b-col>
						<b-col cols="7" class="border-left">
							<div class="content-scroll">
								<ul>
									<li v-for="feat in evaluationData.level.features" :key="feat.id" :id="'levelFeature_'+feat.id">
										<h6  v-show="false">{{feat.title}}</h6>
										<div class="box">
										<div class="content" v-for="detail in feat.featureDetails" :key="detail.id" :id="'levelFeatureDetail_'+detail.id">
											<h6>{{detail.title}}</h6>
											<p>{{detail.description}}</p>
										</div>
										</div>
									</li>
								</ul>
							</div>
						</b-col>
					</b-row>
				</div>
			</div>
			<div class="card card-info">
				<div class="card-body">
					<img class="img-first" src="@/assets/img/info-1.png" />
					<h4>{{$t('planesYPrecios.paso-3.resultado.importante.titulo')}}</h4>
					<p>{{$t('planesYPrecios.paso-3.resultado.importante.texto')}}</p>
				</div>
			</div>
			<div class="text-center mt-5" v-if="!flagEvalGroup">
				<b-button variant="primary" @click="irElegirCursos" :disabled="isLoadingCursos" >
					{{$t('planesYPrecios.paso-3.resultado.importante.button')}}
				</b-button>
				 
			</div>
		</template>
		<ModalNiveles v-if="evaluationData" :levels="levels" :levelAchieved="evaluationData.level.id"/>
		
  </div>
</template>
<script>
	import { baseInstanceAxios } from '@/assets/js/axiosBase.js';
	import ModalNiveles from '@/components/modals/niveles';
	import EvaluacionPreguntas from './evaluacion-preguntas'; 
	import { ValidateIsPlanActive, hideSidebar , hideSidebarNav} from '@/assets/js/util.js';

	export default {
		components: {
    		ModalNiveles, EvaluacionPreguntas
  		},
		props: {
			receivedValue: null,
			nextStep: {
				type: Function,
				default() {
					return {}
				}
			},
			backStep: {
				type: Function,
				default() {
					return {}
				}
			},
			levels: {
				type: Array
			},
			flagEvalGroup:{ type: Boolean},
		},
		data(){
    		return{
				lang:localStorage.getItem('lang') || 'es',
				API_URL: process.env.VUE_APP_API_URL,
				durationEvaluacion: new Date().getTime() + 0,
				currentSong: null,
				flag_resultados:false, 
				step: 0,   
				duration: 0,
				time: '00:00:00',
				currentTime: 0,
				questions: [],
			    evaluation: {
					 id:0,
                     name:'',
                     duration:0 ,
					 durationEvaluationDate:"0001-01-01 00:00:00"
				},
				 
				dataBase: null,
				dataBaseName: 'englishadvance',
				dataBaseVersion: 3,
				dataBaseStorageTable: '',
				carga_evaluacion_flag: false,
				carga_evaluacion_mje : this.$t('planesYPrecios.paso-3.preselección.button-loading'),
				evaluationData : null,
				isLoading: false,
				isLoadingCursos: false
				
    		}
  		},
		computed: {
			UserId: {
				get() {
					return this.$store.state.user_id;
				}
			},
			User: {
				get() {
					return this.$store.state.user;
				}
			},
		},
		async created() {
		
			let planActive  = await  ValidateIsPlanActive(this.User.personStudentId, this.$store.state.authToken); 
			 
			if(!planActive){
				 
				hideSidebar(this.User, 2, this.$store.state.datosSidebar) 
				 
				this.getEvaluation();
				this.getQuestions();
				 
			}else{
				this.$router.push({ name: `dashboard` }).catch(err => {}); 
			}
 
		},
		mounted() {
		
		},
		watch: {
			 
			receivedValue: function(newVal, oldVal) { // watch it
		    	this.flag_resultados = true;
				this.evaluationData = this.receivedValue
				this.step = 2; 
				this.$forceUpdate();
			
			},
			evaluationData: function(newVal, oldVal) { // watch it
		    	
				this.$forceUpdate();
			
			},
			questions: function(newVal, oldVal) {
				//console.log("questions")
			},
        },
		methods: {
			initEvents: function(){
			 
				window.ononline = () => {
					this.$bvToast.hide("toast-equis-internet");
					this.$bvToast.show("toast-check-internet");
				};

				window.onoffline = () => {
					this.$bvToast.hide("toast-check-internet");
					this.$bvToast.show("toast-equis-internet");
				};

				window.onbeforeunload = (event) =>{
					event.preventDefault();
					event.stopImmediatePropagation();
					event.stopPropagation();
				 
				};

				window.onclick = (evt) => {
					//evt.preventDefault();
					console.log(evt);
				};
			},
			 
		   getEvaluation:function(){
			   
			   baseInstanceAxios
					.get(this.API_URL + `/Resources/Evaluations/GetByStudent?PersonStudentId=` + this.receivedValue.personStudentId )
					.then(response => {
						if(response.data != null && response.data.entity != null){
							this.duration = response.data.entity.duration;

		                    let durationEvaluationDate  = new Date("0001-01-01 00:00:00");
                            durationEvaluationDate.setMinutes( durationEvaluationDate.getMinutes() + (response.data.entity.duration));
                            this.evaluation = {
								id:response.data.entity.id,
								name:response.data.entity.name,
								duration:response.data.entity.duration,
								durationEvaluationDate: durationEvaluationDate
				            };
						}
					});
		   },
		   
			getQuestions: function() {
				let flag = this.lang == 'es' ? true : false;
				baseInstanceAxios
					.get(this.API_URL + `/Resources/EvaluationsQuestions/List?Filter=&PersonStudentId=${this.receivedValue.personStudentId}&GroupPersonId=${this.$store.state.group_person_id}&Page=1&Size=100&flagLanguage=${flag}` )
					.then(response => {

						if(response.data != null && response.data.value == 1){  //AUN NO DIO EVALUACIÓN DE NIVEL
							if(response.data.list != null){
								this.initEvents();
								this.questions = response.data.list;
 
								this.carga_evaluacion_mje =  this.$t('planesYPrecios.paso-3.preselección.button'),
								this.carga_evaluacion_flag = true;
							}
						}else if(response.data != null && response.data.value == 0){//YA DIO EVALUACIÓN DE NIVEL
							this.$emit('listenLevel', response.data.entity.groupsPersonsEvaluationsResult.level);
							
							this.evaluationData = response.data.entity.groupsPersonsEvaluationsResult;
					 
							this.flag_resultados = true;
							this.step = 2; 
						}else if(response.data != null && response.data.value == 2){//TIENE NIVEL (PERO NO EVALUACION)
							this.$emit('listenLevel', response.data.entity.groupsPersonsEvaluationsResult.level);
							this.evaluationData = response.data.entity.groupsPersonsEvaluationsResult;
							 
							this.flag_resultados = true;
							this.step = 2; 
						}
						
					});
			}, 
			 
			openDataBase() {
			
				var request = indexedDB.open(this.dataBaseName, this.dataBaseVersion);

				request.onupgradeneeded = function (event) {
							
					this.dataBaseStorageTable = 'table';

					if (event.target.result.objectStoreNames.contains(this.dataBaseStorageTable)) {
						event.target.result.deleteObjectStore(this.dataBaseStorageTable);
					}

					var objectStoreTable = event.target.result.createObjectStore(this.dataBaseStorageTable, { keyPath: this.dataBaseStorageTable + 'id', autoIncrement: true });

					objectStoreTable.createIndex('duration', 'duration', { unique: true });
					objectStoreTable.createIndex('questionsanswersselected', 'questionsanswersselected', { unique: false });
				};

				request.onsuccess = function (event) {
					this.dataBaseStorageTable = 'table';
					this.dataBase = event.target.result;

					var transactionTable = this.dataBase.transaction(this.dataBaseStorageTable, 'readwrite');
					var objectStoreTable = transactionTable.objectStore(this.dataBaseStorageTable);
					objectStoreTable.clear();
					objectStoreTable.add({ duration: this.currentTime, questionsanswersselected: this.questionsAnswersSelecteds });
				};

				request.onerror = function () {
					console.error("open error");
				};
			},
			irElegirCursos(){
				this.isLoadingCursos = true;
				this.nextStep();
			},
			evaluationValueChild(objectEvaluation){
				this.$emit('listenChild', objectEvaluation);
			}
		}
	}
</script>